<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Modules</h5>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="neo-tabs">
          <a-tabs :defaultActiveKey="1" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'"
          @change="handleTabChange">
            <a-tab-pane v-if="sscEnabled" :key="1">
              <span slot="tab">
                Skoolsync Communication Module
              </span>

              <div>
                <sync-history-table />
              </div>
            </a-tab-pane>
            <a-tab-pane :key="2">
              <span slot="tab">
                SMS transactions
              </span>

              <div>
                <p class="font-weight-bold">SMS Balance:
                  <span class="text-danger ml-1">{{ smsBalance }}</span>
                </p>
                <hr>
                <SmsTransactionsTable :schoolId="schoolId" :reload="reloadSmsTransactionHistory" type="admin"/>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { includes } from 'lodash'

import SyncHistoryTable from '@/components/modules/skoolsync/Table'
import SmsTransactionsTable from '@/components/school/Manage/SMS/Transactions/index.vue'

export default {
  components: {
    SyncHistoryTable,
    SmsTransactionsTable,
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      reloadSmsTransactionHistory: false,
      smsBalance: 0,
      dateFormat: 'DD-MM-YYYY',
      boards: [],
      fileList: [],
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
    sscEnabled: function() {
      return includes(this.user.user.school.modules, 'skoolsync')
    },
    schoolId: function() {
      return this.user.user.school.id
    },
  },
  methods: {
    getSmsBalance() {
      this.$http.get('/api/sms/balance')
        .then(({ data }) => {
          this.smsBalance = data.data.balance
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleTabChange(value) {
      if (value === 2) {
        this.getSmsBalance()
        this.reloadSmsTransactionHistory = true
      } else {
        this.reloadSmsTransactionHistory = false
      }
    },
  },
}
</script>
